import React, { ReactElement } from 'react';
import DeleteIcon from '../../icons/delete-icon';
import FormatService from '../../services/format-service';
import useStylesDeleteIconButton from './delete-icon-button.styles';

const DeleteIconButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    className,
    onClick,
  } = props;

  const { classes } = useStylesDeleteIconButton();

  return (
    <DeleteIcon
      className={FormatService.formatClassNames(classes.deleteIconButton, className)}
      onClick={onClick}
    />
  );
});

export default DeleteIconButton;
